import TeleCallerView from "../../../views/TeleCaller";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import TelecallerLeadsView from "../../../views/TelecallerLeads";

const telecallerRoutes = [
  {
    menuName: MenuNames.TELECALLER_PROFILE,
    path: "/telecaller-profile",
    component: TeleCallerView,
    exact: true,
  },
  {
    menuName: MenuNames.TELECALLER_LEAD,
    path: "/telecaller-leads",
    component: TelecallerLeadsView,
    exact: true,
  },
];

export default telecallerRoutes;
